import * as React from 'react';
import s from './PlanSections.scss';
import classNames from 'classnames';
import { TextButton } from '@wix/design-system';
import ArrowIcon from '../AdvancedPlans/PlansGrid/ArrowIcon.svg';
import { Translation } from 'react-i18next';

export const ShowFeaturesButton: React.FC<{ isFeaturesVisible?: boolean }> = ({
  isFeaturesVisible,
}) => (
  <Translation>
    {(t) => (
      <div className={s.collapseButton}>
        <div className={s.collapseText}>
          <TextButton>
            {t(
              isFeaturesVisible
                ? 'Advanced.Plans_General_Hide_features'
                : 'Advanced.Plans_General_Show_features',
            )}
          </TextButton>
        </div>
        <div
          className={classNames(s.collapseIcon, {
            [s.rotated]: isFeaturesVisible,
          })}
        >
          <ArrowIcon />
        </div>
      </div>
    )}
  </Translation>
);
